import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DisplayableItemsComponent } from '../../../../../shared/components/displayable-content/displayable-items/displayable-items.component';
import { DigitalSpotlightTemplatesViewModel } from './digital-spotlight-templates-view-model';

@Component({
  selector: 'app-digital-spotlight-templates',
  templateUrl: './digital-spotlight-templates.component.html',
  styleUrls: ['./digital-spotlight-templates.component.scss'],
  providers: [DigitalSpotlightTemplatesViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DigitalSpotlightTemplatesComponent extends DisplayableItemsComponent {
  constructor(public override viewModel: DigitalSpotlightTemplatesViewModel) {
    super(viewModel);
  }
}
